var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPohoda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.4 198.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M77.3 52.5h102.4v85.9H46.3v-22.6M77.3 70.1h6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    strokeDasharray: "11.5,11.5",
    d: "M95 70.1h64.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M165 70.1h6v6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    strokeDasharray: "14.25,14.25",
    d: "M171 90.3v21.4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M171 118.9v6h-6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    strokeDasharray: "11.5,11.5",
    d: "M153.5 124.9H67.3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M61.5 124.9h-6v-5.3M105 139.8v8.5c-.1 9.9-10.5 9.6-10.5 9.6H70.2v6.4h85.9l-.1-6.4h-24.3s-10.5.4-10.5-9.6v-8.5M77.3 108.7v4.1c0 1.7-1.4 3-3 3H14.4c-1.7 0-3-1.4-3-3V34.7c0-1.7 1.4-3 3-3h47.3L77.3 46v41M77.3 46H61.7M61.7 46V31.6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M64.6 93.9v7.9h20.1v9.5l13.4-14.1-13.7-12.9v9.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "B_4L_main",
    d: "M20.8 75.3v3.1h-2.2v-9.3h3.7c.7 0 1.3.1 1.9.4.5.3 1 .6 1.3 1.1s.4 1 .4 1.6c0 .9-.3 1.6-1 2.2-.6.5-1.5.8-2.7.8h-1.4zm0-1.7h1.5c.4 0 .8-.1 1-.3.2-.2.3-.5.3-.9s-.1-.8-.4-1c-.2-.3-.6-.4-1-.4h-1.5v2.6zM35 74c0 .9-.2 1.7-.5 2.4s-.8 1.2-1.4 1.6c-.6.4-1.3.6-2.1.6s-1.5-.2-2.1-.5-1.1-.9-1.4-1.6c-.3-.7-.5-1.5-.5-2.3v-.5c0-.9.2-1.7.5-2.4s.8-1.2 1.4-1.6 1.3-.6 2.1-.6 1.5.2 2.1.6c.6.4 1.1.9 1.4 1.6s.5 1.5.5 2.4v.3zm-2.3-.4c0-.9-.2-1.6-.5-2.1s-.7-.7-1.3-.7c-1.1 0-1.7.8-1.8 2.5v.7c0 .9.2 1.6.5 2.1s.8.7 1.3.7c.6 0 1-.2 1.3-.7.3-.5.5-1.2.5-2.1v-.4zM44 78.5h-2.2v-3.9h-3.3v3.9h-2.2v-9.3h2.2v3.7h3.3v-3.7H44v9.3zM53.4 74c0 .9-.2 1.7-.5 2.4s-.8 1.2-1.4 1.6c-.6.4-1.3.6-2.1.6s-1.5-.2-2.1-.5-1.1-.9-1.4-1.6c-.3-.7-.5-1.5-.5-2.3v-.5c0-.9.2-1.7.5-2.4s.8-1.2 1.4-1.6 1.3-.6 2.1-.6 1.5.2 2.1.6c.6.4 1.1.9 1.4 1.6s.5 1.5.5 2.4v.3zm-2.3-.4c0-.9-.2-1.6-.5-2.1s-.7-.7-1.3-.7c-1.1 0-1.7.8-1.8 2.5v.7c0 .9.2 1.6.5 2.1s.8.7 1.3.7c.6 0 1-.2 1.3-.7.3-.5.5-1.2.5-2.1v-.4zM54.6 78.5v-9.3h3c.8 0 1.6.2 2.2.6s1.2.9 1.5 1.6c.4.7.6 1.4.6 2.3v.3c0 .8-.2 1.6-.5 2.3-.4.7-.9 1.2-1.5 1.6-.7.4-1.4.6-2.2.6h-3.1zm2.2-7.6v5.8h.8c.6 0 1.1-.2 1.5-.7.3-.5.5-1.1.5-2v-.4c0-.9-.2-1.6-.5-2-.3-.5-.8-.7-1.5-.7h-.8zM68.4 76.7h-3.1l-.5 1.7h-2.4l3.4-9.3h2.1l3.4 9.3h-2.4l-.5-1.7zM65.9 75h2l-1-3.2-1 3.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPohoda);
export default __webpack_public_path__ + "static/media/pohoda.23e5b733ca50a8d913a6f05a6565f21a.svg";
export { ForwardRef as ReactComponent };